import type React from 'react'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useNavigate } from 'react-router-dom'
import type { ICellRendererParams } from 'ag-grid-community'
import { handleNavigation } from '../../../utils/navigationHelpers'

interface TerminalNameCellRendererProps extends ICellRendererParams {
  data: {
    terminalId: string
    terminalName: string
    invoiceCount: number
    bolCount: number
    pastDueAmount: number
  }
  context?: {
    assignedToMe?: boolean
    dateRange?: {
      start: Date
      end: Date
    }
    supplierName?: string
  }
}

export function TerminalNameCellRenderer({ data, context }: TerminalNameCellRendererProps) {
  const navigate = useNavigate()
  const assignedToMe = context?.assignedToMe || false
  const dateRange = context?.dateRange
  const supplierName = context?.supplierName

  function createMatchViewUrl() {
    const params = new URLSearchParams()
    params.append('tab', 'all_open')

    if (dateRange) {
      params.append('date_range[]', dateRange.start.toISOString())
      params.append('date_range[]', dateRange.end.toISOString())
    }

    if (data?.terminalName) {
      params.append('terminal_name', data.terminalName)
    }

    if (supplierName) {
      params.append('supplier_name', supplierName)
    }

    params.append('assigned_to_me', assignedToMe ? 'true' : 'false')

    return `/supplier_rec/match_view?${params.toString()}`
  }

  function handleClick(event: React.MouseEvent) {
    if (data?.terminalName) {
      const url = createMatchViewUrl()
      handleNavigation(url, navigate, event)
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start' }}>
      <GraviButton appearance='link' size='small' onClick={handleClick} style={{ textAlign: 'left', padding: 0 }}>
        <Texto
          category='p2'
          appearance='default'
          weight='400'
          style={{ fontSize: '14px', textDecoration: 'underline' }}
        >
          {data?.terminalName || 'N/A'}
        </Texto>
      </GraviButton>
    </div>
  )
}
